"use client";
import React from "react";
import { isShopOpenNow } from "utils/openingHours";

/**
 * "Đang mở cửa?" cho trang shop.
 * - `initial`: server tính sẵn theo giờ VN → HTML có nhãn, hydrate khớp.
 * - Sau mount KHÔNG tính lại ngay (tránh nhấp nháy nhãn khi ISR cache lệch vài phút),
 *   chỉ cập nhật mỗi phút — đủ để trang cache cũ tự đúng dần.
 * Trả về true/false; null = không đủ dữ liệu giờ.
 */
export default function useOpenNow(
  openHour?: string,
  closeHour?: string,
  isClosed = false,
  initial?: boolean | null,
): boolean | null {
  const [openNow, setOpenNow] = React.useState<boolean | null>(
    initial !== undefined ? initial : isClosed ? false : isShopOpenNow(openHour, closeHour, isClosed),
  );
  React.useEffect(() => {
    const id = window.setInterval(
      () => setOpenNow(isShopOpenNow(openHour, closeHour, isClosed)),
      60_000,
    );
    return () => window.clearInterval(id);
  }, [openHour, closeHour, isClosed]);
  return openNow;
}
